var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{ref:"xTable",attrs:{"resizable":"","data":_vm.tableData,"size":"mini","mouse-config":{ area: true },"highlight-hover-row":"","highlight-current-row":"","height":_vm.tableHeight,"columns":_vm.gridColumns,"cell-style":_vm.tableCellStyle,"row-config":{ height: 60 },"showOverflow":true,"tooltip-config":{
    showAll: true,
    theme: 'dark'
  },"keyboard-config":{
    isArrow: true,
    isEnter: true,
    isTab: true,
    isClip: true,
    enterToTab: true,
    isEdit: true
  },"sort-config":{
    trigger: 'cell',
    orders: ['desc', 'asc', null]
  },"seq-config":{
    startIndex: (_vm.tablePage.currentPage - 1) * _vm.tablePage.pageSize
  },"pager-config":_vm.tablePage},on:{"page-change":_vm.handlePageChange,"cell-dblclick":_vm.handleDbClick}})}
var staticRenderFns = []

export { render, staticRenderFns }